import {trackRelateKeywords} from "@spa/features/search_job/pc/api/analytics/trackEvent";
import {useTrack} from "@spa/features/search_job/pc/contexts/TrackContext";

const RelatedKeywordList = ({searchResultViewModel}) => {
    const {channelName} = useTrack();
    const relatedKeywordListViewModel = searchResultViewModel.relatedKeywordListViewModel;
    const relateKeywordNearMeListViewModel = searchResultViewModel.relateKeywordNearMeListViewModel;

    const RelatedKeyword = relatedKeywordListViewModel.list?.map((listItem, index) => {
        return (
            <a key={index} href={listItem.url} className="c-related_link c-related_link--kw" onClick={() => trackRelateKeywords(channelName)}>{listItem.displayText}</a>
        );
    });

    const RelatedNearMe = relateKeywordNearMeListViewModel.list?.map((listItem, index) => {
        return (
            <a key={index} href={listItem.url} className="c-related_link c-related_link--kw" onClick={() => trackRelateKeywords(channelName)}>{listItem.displayText}</a>
        );
    });

    return (
        <>
            {!relatedKeywordListViewModel.isEmpty &&
                <div className="p-related">
                    <h3 className="p-result_ttl">{searchResultViewModel.translations.relate_keyword.people_also_searched}</h3>
                    <div className="c-related_box c-related_box--search">
                        {RelatedKeyword}
                    </div>
                </div>
            }
            {!relateKeywordNearMeListViewModel.isEmpty &&
                <div className="p-related">
                    <h3 className="p-result_ttl">{searchResultViewModel.translations.relate_keyword.jobs_near_me}</h3>
                    <div className="c-related_box c-related_box--search">
                        {RelatedNearMe}
                    </div>
                </div>
            }
        </>
    );
}

export default RelatedKeywordList;
